import React from 'react';

import Button from '@sats-group/ui-lib/react/button/button';
import Checkbox from '@sats-group/ui-lib/react/checkbox/checkbox';
import Modal from '@sats-group/ui-lib/react/modal/modal';

import RichText from '../rich-text/rich-text';

import type { Terms as Props } from './terms.props';

const Terms: React.FunctionComponent<Props> = ({
  button,
  checkbox,
  modal,
  terms,
}) => (
  <div className="terms">
    <div className="terms__checkbox">
      <Checkbox theme={Checkbox.themes.blue} {...checkbox} />
    </div>
    {button && modal ? (
      <Button
        {...button}
        className="terms__button"
        popoverTarget={modal.id}
        size={Button.sizes.small}
        variant={Button.variants.tertiary}
      />
    ) : null}
    {modal && terms ? (
      <Modal {...modal}>
        <RichText {...terms} />
      </Modal>
    ) : null}
  </div>
);

export default Terms;
